module.exports = __webpack_public_path__ + "img/aneel.9e589c39.jpg";